document.documentElement.classList.remove('no-js');

(function () {
  const header = document.querySelector('[data-site-header]');
  if (!header) return;

  const toggle = header.querySelector('[data-mobile-toggle]');
  const drawer = header.querySelector('[data-mobile-nav]');
  const closeButton = header.querySelector('[data-mobile-close]');
  const overlay = header.querySelector('[data-mobile-overlay]');

  const setMenuState = (open) => {
    if (!toggle || !drawer || !overlay) return;
    drawer.classList.toggle('is-open', open);
    overlay.classList.toggle('is-open', open);
    overlay.hidden = !open;
    drawer.setAttribute('aria-hidden', String(!open));
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    document.body.classList.toggle('mobile-menu-open', open);
  };

  if (toggle) toggle.addEventListener('click', () => setMenuState(toggle.getAttribute('aria-expanded') !== 'true'));
  if (closeButton) closeButton.addEventListener('click', () => setMenuState(false));
  if (overlay) overlay.addEventListener('click', () => setMenuState(false));

  header.querySelectorAll('[data-mobile-submenu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const submenu = button.closest('.mobile-nav__group')?.querySelector('.mobile-submenu');
      if (!submenu) return;
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      button.textContent = open ? '+' : '−';
      submenu.hidden = open;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setMenuState(false);
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 990) setMenuState(false);
  });
})();
